import { render } from "./SemesterSchoolyear.vue?vue&type=template&id=37a089f2"
import script from "./SemesterSchoolyear.vue?vue&type=script&lang=js"
export * from "./SemesterSchoolyear.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__